import React from 'react';
import { compose, lifecycle, withState } from 'recompose';
import { socialLoginRedirectUrl, socialLoginRevoke } from '../Common/Providers/SocialLoginApi';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { withTranslationProvider } from '../Common/Translations';

const handleGoogleConnect = () => {
  socialLoginRedirectUrl(data.provider)
  .done((response) => {
    window.location = response.data.redirect_url;
  })
};

const handleGoogleRevoke = () => {
    socialLoginRevoke(data.provider)
    .done(() => {
        window.location.reload();
    });
};

const data = { 
  provider: 'google',
};

const ConnectWithGoogle = (props) => {
  const {
    isLinked,
    t,
  } = props;

  return (
    <div className="col-md-auto mb-3">
      <button
        className = "btn btn-outline-gray-lighten-1"
        id = "btn-social-login"
        onClick = { isLinked ? () => handleGoogleRevoke() : () => handleGoogleConnect() }>
        <img className="google-icon pr-4" src={`/img/svg/googleLogo.svg`}/>
        { isLinked ? t('account.unlink_google','Unlink from Google') : t('account.connect_google','Connect with Google') }
      </button>
  </div>
  );
}

const enhance = compose(
  connectUserHeaderinfo,
  withTranslationProvider,
  withState('isLinked', 'setIsLinked', false),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        userHeaderInfo: {
          hasSocialMediaLink = {}
        }
      } = this.props;
      const googleLink = hasSocialMediaLink.google || {};
      const { isLinked = false } = googleLink;
  
      if (isLinked !== prevProps.isLinked) {
        this.props.setIsLinked(isLinked);
      }
    }
  }),
);

export default enhance(ConnectWithGoogle);
export const undecorated = ConnectWithGoogle;


// WEBPACK FOOTER //
// ./src/Account/ConnectWithGoogle.js